const DEFAULT_OPTIONS = {
    maxLeadSeconds: 0.08,
    maxLeadDistance: 0.42,
    maxSpeed: 24,
    catchupRate: 26,
    snapshotCorrection: 0.85,
};
export function createBladeTipPredictor(initialTip, options = {}) {
    return {
        rendered: { ...initialTip },
        latestSnapshot: { ...initialTip },
        previousSnapshot: null,
        velocity: { x: 0, y: 0 },
        latestSnapshotAtMs: Number.NEGATIVE_INFINITY,
        options: { ...DEFAULT_OPTIONS, ...options },
    };
}
export function resetBladeTipPredictor(predictor, tip) {
    return {
        ...predictor,
        rendered: { ...tip },
        latestSnapshot: { ...tip },
        previousSnapshot: null,
        velocity: { x: 0, y: 0 },
        latestSnapshotAtMs: Number.NEGATIVE_INFINITY,
    };
}
export function updateBladeTipPrediction(predictor, input) {
    if (input.kind === "snapshot") {
        const velocity = measureVelocity(predictor, input.tip, input.receivedAtMs);
        return {
            ...predictor,
            rendered: lerpVec(predictor.rendered, input.tip, clamp01(predictor.options.snapshotCorrection)),
            previousSnapshot: predictor.latestSnapshot,
            latestSnapshot: { ...input.tip },
            latestSnapshotAtMs: input.receivedAtMs,
            velocity,
        };
    }
    const ageSeconds = Math.max(0, (input.nowMs - predictor.latestSnapshotAtMs) / 1000);
    const leadSeconds = Math.min(ageSeconds, predictor.options.maxLeadSeconds);
    const predicted = clampLead({
        x: predictor.latestSnapshot.x + predictor.velocity.x * leadSeconds,
        y: predictor.latestSnapshot.y + predictor.velocity.y * leadSeconds,
    }, predictor.latestSnapshot, predictor.options.maxLeadDistance);
    const alpha = 1 - Math.exp(-predictor.options.catchupRate * input.dtSeconds);
    return {
        ...predictor,
        rendered: lerpVec(predictor.rendered, predicted, clamp01(alpha)),
    };
}
function measureVelocity(predictor, tip, receivedAtMs) {
    if (!Number.isFinite(predictor.latestSnapshotAtMs))
        return { x: 0, y: 0 };
    const dtSeconds = (receivedAtMs - predictor.latestSnapshotAtMs) / 1000;
    if (dtSeconds <= 0)
        return { x: 0, y: 0 };
    const raw = {
        x: (tip.x - predictor.latestSnapshot.x) / dtSeconds,
        y: (tip.y - predictor.latestSnapshot.y) / dtSeconds,
    };
    return clampMagnitude(raw, predictor.options.maxSpeed);
}
function clampLead(tip, latest, maxDistance) {
    const offset = { x: tip.x - latest.x, y: tip.y - latest.y };
    const clamped = clampMagnitude(offset, Math.max(0, maxDistance));
    return { x: latest.x + clamped.x, y: latest.y + clamped.y };
}
function clampMagnitude(v, maxMagnitude) {
    const magnitude = Math.hypot(v.x, v.y);
    if (magnitude <= maxMagnitude || magnitude === 0)
        return v;
    const scale = maxMagnitude / magnitude;
    return { x: v.x * scale, y: v.y * scale };
}
function lerpVec(a, b, t) {
    return {
        x: a.x + (b.x - a.x) * t,
        y: a.y + (b.y - a.y) * t,
    };
}
function clamp01(value) {
    if (value <= 0)
        return 0;
    if (value >= 1)
        return 1;
    return value;
}
//# sourceMappingURL=blade-tip-predictor.js.map